export const PermissionAllocation = {
    PUT: "change_allocation",
    POST: "add_allocation",
    DELETE: "delete_allocation",
    VIEW: "view_allocation",
    PRE_REGISTER: "can_pre_register_container_allocation",
    EXPORT: "can_export_allocation",
    IMPORT: "can_export_allocation",
    MERGE: "can_merge_allocation",
};